import { get } from 'lodash';
import { initialState } from './initialState';
import * as constants from './constants';
import produce from 'immer';

// ===========================|| ACCOUNT REDUCER ||=========================== //

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.INIT_PROJECTS:
      return produce(state, (draft) => {
        const projects = action.payload;
        draft.projectIds = [];
        draft.projectsById = {};
        projects.forEach((project, idx) => {
          const { id } = project;
          draft.projectsById[id] = project;
          draft.projectIds.push(id);
          // Select the first project
          if (idx === 0) {
            draft.selectedProjectIds = [id];
            draft.selectedCasingIds = [];
            draft.selectedSensitivityIds = [];
          }
        });
      });

    case constants.SELECT_PROJECTS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedProjectIds = ids;
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.ADD_PROJECT:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.projectsById[id] = action.payload;
        draft.projectIds.push(id);
        // // Insert new case to select
        // draft.selectedProjectIds.unshift(id);
        draft.selectedProjectIds = [id];
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.REMOVE_PROJECT:
      return produce(state, (draft) => {
        const id = action.payload;
        // Delete in obj and children obj
        delete draft.projectsById[id];
        delete draft.inputGeneralByProjectId[id];
        // Delete in order array
        const idx = draft.projectIds.findIndex((projId) => projId === id);
        if (idx !== -1) draft.projectIds.splice(idx, 1);
        // Delete in selectedProjectIds
        const selectId = draft.selectedProjectIds.findIndex((projId) => projId === id);
        if (selectId !== -1) draft.selectedProjectIds.splice(selectId, 1);
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.UPDATE_PROJECT:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.projectsById[id] = action.payload;
      });

    case constants.UPDATE_PROJECT_INPUT_GENERAL:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.inputGeneralByProjectId[projectId] = obj;
        }
      });

    case constants.UPDATE_PROJECT_INPUT_PRESSURE:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.inputPressureByProjectId[projectId] = obj;
        }
      });

    case constants.UPDATE_PROJECT_INPUT_PLUG_PROGRAM:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.inputPlugProgramByProjectId[projectId] = obj;
        }
      });

    case constants.UPDATE_PROJECT_INPUT_CASING_PROGRAM:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.inputCasingProgramByProjectId[projectId] = obj;
        }
      });

    case constants.UPDATE_PROJECT_INPUT_ZONE_PROGRAM:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.inputZoneProgramByProjectId[projectId] = obj;
        }
      });

    case constants.UPDATE_PROJECT_OUTPUT:
      return produce(state, (draft) => {
        const obj = action.payload;
        const { output_summary: objA, output_detail: objB, output_time_series: objC } = obj;
        const projectIdA = get(objA, 'project_id', null);
        if (projectIdA) {
          draft.outputSummaryByProjectId[projectIdA] = objA;
        }
        const projectIdB = get(objB, 'project_id', null);
        if (projectIdB) {
          draft.outputDetailByProjectId[projectIdB] = objB;
        }
        const projectIdC = get(objC, 'project_id', null);
        if (projectIdC) {
          draft.outputTimeSeriesByProjectId[projectIdC] = objC;
        }
      });
    case constants.UPDATE_PROJECT_OUTPUT_SUMMARY:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.outputSummaryByProjectId[projectId] = obj;
        }
      });
    case constants.UPDATE_PROJECT_OUTPUT_TIME_SERIES:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.outputTimeSeriesByProjectId[projectId] = obj;
        }
      });
    case constants.UPDATE_PROJECT_OUTPUT_DETAIL:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.outputDetailByProjectId[projectId] = obj;
        }
      });
    case constants.UPDATE_PROJECT_OUTPUT_PLUG_PROGRAM:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.outputPlugProgramByProjectId[projectId] = obj;
        }
      });
    case constants.UPDATE_PROJECT_OUTPUT_SPACE:
      return produce(state, (draft) => {
        const obj = action.payload;
        const projectId = get(obj, 'project_id', null);
        if (projectId) {
          draft.outputSpaceByProjectId[projectId] = obj;
        }
      });
    case constants.SELECT_CASINGS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedCasingIds = ids;
      });
    case constants.SELECT_PLUGS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedPlugIds = ids;
      });

    case constants.SELECT_ZONES:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedZoneIds = ids;
      });

    case constants.SELECT_CURRENT_LAYOUT:
      return produce(state, (draft) => {
        const currentLayout = action.payload;
        draft.currentLayout = currentLayout;
      });

    case constants.UPDATE_SETTINGS:
      return produce(state, (draft) => {
        const settings = action.payload;
        draft.settings = settings;
      });

    default:
      return state;
  }
};

export default reducer;
